import React from 'react';
import styled from 'styled-components';

import { mediaQueryLaptopMin } from 'styles';

const BannerSection = styled(({ hideOnMobile, sticky, ...props }) => (
  <section {...props} />
))`
  padding: 0;
  margin: 0;
  width: 100%;

  ${({ hideOnMobile }) => {
    if (hideOnMobile) {
      return `
        display: none;

        @media all and ${mediaQueryLaptopMin} {
          display: block;
        }
      `;
    }

    return '';
  }}

  ${({ sticky }) => {
    if (sticky) {
      return `
        position: sticky;
        top: 16px;
      `;
    }

    return '';
  }}
`;

export default BannerSection;
